import { AnyAction, Reducer } from 'redux';
import { Claim, getClaim, getPropertyFromClaim } from '../../../../claim';
import { CommunicationDetails } from '../../../../forms/sub-forms/communication-details';
// import { collectionReducer } from '../../../../redux/collection-reducer';
import { combineReducersWithDefault } from '../../../../redux/combine-reducers-with-default';
import { State } from '../../../../redux/root-reducer';
import { Nullable } from '../../../../shared-types';

export interface OtherDetails {
    highestQualification: string;
    hasInsolvency: string;
    consumesAlcohol: string;
    totCount: string;
    wineGlassCount: string;
    beerCanOrCider: string;
    receivedAdviceToReduceAlcohol: string;
    alcoholAdviceDetails: string;
    practiceAvocation: string;
    practiceAvocationDetails: string;
    hoursWorkedPerWeek: string;
    wasRetired: string;
    retirementFullDetails: string;
}

export interface InsuranceCompany {
    nameOfInsuranceCompany: string;
    policyNumber: string;
    dateOfInception?: Date;
    estimatedValue: number;
}
export interface OtherInsurance {
    haveYouClaimedOrDoYouIntendOnClaimingForPaymentOfDisabilityDreadDiseasesImpairmentOrAnySimilarBenefitsWithOtherInsuranceCompany: string;
    insuranceCompany?: InsuranceCompany[];
    CoHaveYouClaimedOrDoYouIntendOnClaimingForPaymentOfDisabilityDreadDiseasesImpairmentOrAnySimilarBenefitsWithOtherInsuranceCompany?: string;
}

export interface OtherInsurancePolicies {
    otherInsurance?: OtherInsurance;
}

export interface MedicalAidDetails {
    hasMedicalAid: string;
    isLifeAssuredMainMember: string;
    lifeAssuredMedicalDateJoined: Date;
    lifeAssuredMedicalAidDescription: string;
    lifeAssuredIdNumber: string;
    lifeAssuredMedicalAidName: string;
    lifeAssuredMedicalAidNumber: string;
    lifeAssuredName: string;
    lifeAssuredSurname: string;
    lifeAssuredTitle: string;
    doesTheLifeAssuredHaveAMedicalAid?: string;
    medicalAidName?: string;
    otherMedicalAidName?: string;
    medicalAidNumber?: string;
    dateJoined?: Nullable<Date>;
    isLifeAssuredMainMemberOnTheMedicalAid?: string;
    mainMembersFirstName?: string;
    mainMembersSurname?: string;
    mainMembersIdNumberOrPassportNumber?: string;
}
export interface occurences {
    dateOfAttendance: Date;
    reason: string;
}

export interface AddressDetails {
    readonly addressType?: string;
    readonly addressLineOne?: string;
    readonly addressLineTwo?: string;
    readonly addressLineThree?: string;
    readonly addressLineFour?: string;
    readonly addressSuburb?: string;
    readonly postalCode?: string;
    readonly town?: string;
    readonly province?: string;
    readonly country?: string;
    readonly postalAddressAddressType?: string;
    readonly postalAddressCode?: string;
    readonly postalAddressCountry?: string;
    readonly postalAddressLineOne?: string;
    readonly postalAddressLineThree?: string;
    readonly postalAddressLineTwo?: string;
    readonly postalAddressProvince?: string;
    readonly postalAddressSuburb?: string;
    readonly postalAddressTown?: string;
    // readonly sameAsResidential?: string;
    readonly sameAsResidentialAddress?: boolean;
    readonly postalPostalCode?: string;
    readonly townOrSuburb?: string;
    readonly city?: string;
    readonly address?: string;
    readonly suburb?: string;
}
export interface DoctorVisits {
    addressDetails?: AddressDetails;
    doctorsContactDetails?: string;
    doctorsName?: string;
    emailAddress: string;
    occurences: Array<occurences>;
    practiceNumber: string;
    pleaseProvideDetailsOfConsultation?: string;
    consultationDate: Date;
}

export interface MedicalInformaion {
    doctorVisits?: Array<DoctorVisits>;
    extractOfMedicalHistory?: string;
    extractOfMedicalHistory1?: string;
    lifeAssuredAccidentDetails?: string;
    lifeAssuredDateOfDiagnosis?: Date;
    lifeAssuredMedicalCondition?: string;
    lifeAssuredMedicalEvidence?: string;
    lifeAssuredMedicalReason?: string;
    lifeAssuredlistMedicationTreatment?: string;
    takingMedicationOrTreatment?: string;
    lifeAssuredMoreInformation?: string;
}

export interface ContactDetails extends CommunicationDetails {
    sameDetailsAsFa?: boolean;
    homeTelephoneNumber?: string;
    workTelephoneNumber?: string;
}

export interface PersonalDetails {
    companyName?: string;
    consultantCode?: string;
    countryOfBirth?: Date;
    countryOfIssue?: string;
    countryOfResidence?: string;
    dateOfBirth?: Date;
    dateOfExpiry?: Date;
    dateOfIssue?: Date;
    dateOfMarriage?: Date;
    firstName?: string;
    gender?: string;
    idNumber?: string;
    initials?: string;
    isRSAResident?: string;
    maiden?: string;
    maritalStatus?: string;
    passportNumber?: string;
    placeOfBirth?: string;
    proofOfIdentification?: string;
    howLongHasThePolicyBeenActiveFor?: string;
    surname?: string;
    title?: string;
    incomeTaxNumber?: string;
    lifeAssuredPolicyActivePeriod?: string;
    lifeAssuredCountryOfBirth?: string;
    lifeAssuredCountryOfIssue?: string;
    lifeAssuredCountryOfResidence?: string;
    lifeAssuredDateOfBirth?: Date;
    lifeAssuredDateOfIssue?: Date;
    lifeAssuredDateOfMarriage?: Date;
    lifeAssuredFirstName?: string;
    lifeAssuredGender?: string;
    lifeAssuredIdNumber?: string;
    lifeAssuredIncomeTaxNumber?: string;
    lifeAssuredIsRSAResident?: string;
    hasMaritalStatusChanged?: string;
    lifeAssuredMaritalStatus?: string;
    lifeAssuredPassportNumber?: string;
    lifeAssuredPlaceOfBirth?: string;
    lifeAssuredProofOfIdentification?: string;
    lifeAssuredSurname?: string;
    lifeAssuredTitle?: string;
    whoseDetailsAreBeingEntered?: string;
    fullFirstNames?: string;
    areYouASouthAfricanResident?: string;
    dateOfDivorce?: Date;
    cellphoneNumber?: string;
    emailAddress?: string;
    isTheLifeAssuredTheSameAsPolicyHolder?: string;
    relationshipToPolicyHolder?: string;
    otherRelationship?: string;
    hasYourMaritalStatusChangedSinceYouTookUpThePolicy?: string;
}

export interface HealthInformation {
    whatIsYourHighestQualification?: string | null;
    haveYouEverBeenDeclaredInsolventOrAreSequestrationHearingProceedingsPendingOrCompleted?:
        | string
        | null;
    doYouConsumeAlcohol?: string | null;
    howManySpiritsAndTotsPerWeek?: number | null;
    howManyWinesInAGlassPerWeek?: number | null;
    howManyBeersOrCidersInACanOrBottlePerWeek?: number | null;
    haveYouEverReceivedAdviceToReduceOrDiscontinueAlcoholConsumption?: string | null;
    pleaseProvideFullDetailsOfTheAdvice?: string | null;
    haveYouEverBeenChargedWithDrunkenDriving?: string | null;
    pleaseProvideFullDetailsOfDrunkenDrivingCharge?: string | null;
    doYouCurrentlyPracticeAnyAvocations?: string | null;
    pleaseProvideFullDetailsOfTheAvocations?: string | null;
    pleaseProvideTheAverageNumberOfHoursThatYouWereWorkingPerWeek?: string | null;
    wereYouPartiallyOrFullyRetiredAtTheDateOfTheClaimEvent?: string | null;
    retirementFullDetails?: string | null;
}

export interface Occurences {
    dateOfAttendance: Date;
    reason?: string;
    drDateOfAttendance: Date;
    drReason?: string;
}

export interface DoctorVisit {
    occurences?: Occurences[];
    addressDetails?: AddressDetails;
    doctorsName?: string;
    doctorsContactNumber?: string;
    drDoctorsName?: string;
    drDoctorsContactNumber?: string;
}

export interface DisabilityClaimConditions {
    doctorVisits?: DoctorVisits[];
    lifeAssuredMedicalReason?: string;
    lifeAssuredDateOfDiagnosis: Date;
    lifeAssuredMedicalCondition?: string;
    lifeAssuredAccidentDetails?: string;
    drLifeAssuredMedicalReason?: string;
    drLifeAssuredDateOfDiagnosis: Date;
    drLifeAssuredMedicalCondition?: string;
    drLifeAssuredAccidentDetails?: string;
    whatFormOfTreatmentOrMedicationAreYouCurrentlyTaking?: string;
    drWhatFormOfTreatmentOrMedicationAreYouCurrentlyTaking?: string;
}

export interface RetrenchmentClaimConditions {
    doctorVisits?: DoctorVisits[];
    pastDoctorVisit?: string;
    drLifeAssuredPastDoctorVisit?: string;
}
export interface LifeAssuredDetails {
    addressDetails?: AddressDetails;
    contactDetails?: ContactDetails;
    personalDetails?: PersonalDetails;
    otherDetails?: OtherDetails;
    medicalAidDetails?: MedicalAidDetails;
    medicalInformation?: MedicalInformaion;
    healthInformation?: HealthInformation;
    otherInsurancePolicies?: OtherInsurancePolicies;
    disabilityClaimConditions?: DisabilityClaimConditions;
    retrenchmentClaimConditions?: RetrenchmentClaimConditions;
}

export interface Declaration {
    certifiedBy?: string;
    firstName?: string;
    secondName?: string;
    lastName?: string;
    idNumber?: string;
    telephoneNumber?: string;
    hospitalName?: string;
    hospitalContactNo?: string;
    addressDetails?: AddressDetails;
    firstNameAndSurname?: string;
    agreedToTermsAndConditions?: boolean;
}

export interface PaymentInformation {
    paymentBeneficiary?: string | null;
    accountType?: string | null;
    doesAccountBelongToAnIndividualOrABusiness?: string | null;
    accountHolderRelationship?: string | null;
    isTheAccountHolderASouthAfricanResident?: string | null;
    bankName?: string | null;
    branchCode?: string | null;
    branchName?: string | null;
    accountNumber?: string | null;
    accountHolderFirstName?: string | null;
    fullFirstNameOfAccountHolder?: string | null;
    relationshipToPolicyHolder?: string | null;
    surname?: string | null;
    idNumber?: string | null;
    passportNumber?: string | null;
    countryOfResidence?: string | null;
    countryOfcompany?: string | null;
    companyName?: string | null;
    companyRegistrationDate?: Nullable<Date>;
    companyRegistrationNumber?: string | null;
}

export interface Information {
    accountHolderFirstName?: string;
    accountNumber?: string;
    accountType?: string;
    bankName?: string;
    branchCode?: string;
    branchName?: string;
    companyName?: string;
    companyRegistrationDate?: Date;
    companyRegistrationNumber?: string;
    countryOfIncorporation?: string;
    idNumber?: string;
    isRSAResident?: string;
    paymentBeneficiary?: string;
    policyHolderType?: string;
    relationshipToAccountHolder?: string;
    relationshipToPolicyHolder?: string;
    surname?: string;
}

export interface Payment {
    information?: Information;
    paymentInformation?: PaymentInformation;
}

export interface CompanyDetails {
    companyName?: string;
    companyTradingName?: string;
    companyRegistrationNumber?: string;
    companyRegistrationDate: Date;
    countryOfIncorporation?: string;
    countryOfCompany?: string;
    howLongHasThePolicyBeenActiveFor?: string;
    phCompanyName?: string;
    phCompanyRegistrationNumber?: string;
    phRegistrationDate: Date;
    phCountryOfIncorporation?: string;
    entityRegistrationNumber?: string;
    dateOfIncorporation: Date;
    entityName?: string;
    entityAddressLine1?: string;
    entityAddressLine2?: string;
    entityProvince?: string;
    entityPostalCode?: string;
    entitySuburb?: string;
    entityTown?: string;
}

export interface EmploymentDetails {
    hasTaxNumber: string;
    isPolicyHolderEmployed: string;
    nominatedOccupation: string;
    industryOfOccupation: string;
    policyholdersOccupation?: string | null;
    inWhichIndustry?: string | null;
    taxOffice?: string | null;
    saTaxReferenceNumber: string;
    employerName: string;
    saIncomeTaxReferenceNumber?: string | null;
    nameOfCurrentOrPreviousEmployer?: string | null;
    nameOfEmployer?: string | null;
    address?: string | null;
    postalCode?: string | null;
    contactNumber?: string | null;
    emailAddress?: string | null;
    dateEmployedFrom?: Nullable<Date>;
    dateEmployedTo?: Nullable<Date>;
    effectiveDateOfRetrenchment?: Nullable<Date>;
    employerContractBasis?: string | null;
    whatWasYourFullTimeOccupationBeforeYourCurrentDisability?: string | null;
    whichOfTheFollowingItemsDescribesTheWorkThatYouDo?: string[] | null;
    pleaseProvideAnAccurateDescriptionOfTheExactNatureAndDutiesOfYourFullTimeOccupation?:
        | string
        | null;
    isThereAnyHazardAssociatedWithYourOccupation?: string | null;
    pleaseProvideDetailsRelatingToHazardsAssociatedWithYourOccupation?: string | null;
    doYouTravelBeyondTheBordersOfSouthAfricaInTheCourseOfYourDuties?: string | null;
    pleaseProvideDetailsOfCountryThatYouTravelToAndTheNatureOfYourDuties?: string | null;
    whatDateDidYouStopWorking?: Nullable<Date>;
    whenDoYouExpectToReturnToWork?: Nullable<Date>;
    pleaseProvideDetailsOfYourWellBeing?: string | null;
    haveYouBeenOfferedOrHaveEnquiredOnAnyAlternativeOccupationForRenumerationByYourEmployer?:
        | string
        | null;
    whaTypeOfOccupationWillItBe?: string | null;
}
export interface EmploymentHistory {
    companyName?: string | null;
    employerName?: string | null;
    natureOfOccupation?: string | null;
    yearsInService?: string | null;
    contactNumber?: string | null;
    emailAddress?: string | null;
    startDate?: Nullable<Date>;
    endDate?: Nullable<Date>;
    dateEmployedFrom?: Nullable<Date>;
    dateEmployedTo?: Nullable<Date>;
}

export interface Individual {
    addressDetails?: AddressDetails;
    companyDetails?: CompanyDetails;
    contactDetails?: ContactDetails;
    employmentDetails?: EmploymentDetails;
    personalDetails?: PersonalDetails;
}

export interface PolicyHolderDetails {
    individual?: Individual;
    policyHolderType?: string;
    isThePolicyHolderAnIndividualOrCompany?: string;
}

export interface PolicyDetails {
    claimingCapacity?: string;
    isOwner?: string;
    policyNumber?: string;
}

export interface ClaimantDetails {
    policyNumbers?: string[];
    whoseDetailsAreBeingEntered?: string;
    companyName?: string;
    consultantCode?: string;
    title?: string;
    firstName?: string;
    surname?: string;
    cellphoneNumber?: string;
    workNumber?: string;
    emailAddress?: string;
    preferredMethodOfCommunication?: string[];
}

export interface Claimant {
    contactDetails?: ContactDetails;
    personalDetails?: PersonalDetails;
    policyDetails?: PolicyDetails;
    claimantDetails?: ClaimantDetails;
}

export interface SourcesOfIncome {
    sourceOfIncome?: string | null;
    incomeAmount?: string | null;
    date?: Nullable<Date>;
}

export interface IncomeDetails {
    sourcesOfIncome?: SourcesOfIncome[] | null;
    whatWasYourTaxableIncomeForThePastTwelveMonths?: string | null;
    whatWasYourCommissionEarnedDuringThePastFourMonths?: string | null;
    pleaseProvideDirectorFeesOverThePast24Months?: string | null;
    haveYouReceivedAnyIncomeOrAnyOtherBenefitsSinceDisablement?: string | null;
}

export interface Employment {
    employmentDetails?: EmploymentDetails | null;
    employmentHistory?: EmploymentHistory[] | null;
    incomeDetails?: IncomeDetails | null;
}

export const defaultClaimant: Claimant = {
    contactDetails: {},
    policyDetails: {},
    personalDetails: {},
    claimantDetails: {},
};

export interface FormDetails {
    lifeAssured?: LifeAssuredDetails;
    declaration?: Declaration;
    payment?: Payment;
    policyHolder?: PolicyHolderDetails;
    claimant?: Claimant;
    declarationInformation?: '';
    employment?: Employment;
    claimType?: '';
}

export const defaultFormDetails: FormDetails = {
    lifeAssured: {},
    declaration: {},
    payment: {},
    policyHolder: {},
    claimant: {},
    declarationInformation: '',
    employment: {},
    claimType: '',
};

const defaultFormDetailsList: FormDetails[] = [];

const lifeAssuredReducer: Reducer<LifeAssuredDetails | undefined, AnyAction> = (
    state: LifeAssuredDetails = {},
    action: AnyAction
) => {
    switch (action.type) {
        default:
            return state;
    }
};

const declarationReducer: Reducer<Declaration | undefined, AnyAction> = (
    state: Declaration = {},
    action: AnyAction
) => {
    switch (action.type) {
        default:
            return state;
    }
};

const paymentReducer: Reducer<Payment | undefined, AnyAction> = (
    state: Payment = {},
    action: AnyAction
) => {
    switch (action.type) {
        default:
            return state;
    }
};

const declarationInformationReducer: Reducer<'' | undefined, AnyAction> = (state = '', action) => {
    switch (action.type) {
        default:
            return state;
    }
};

const claimTypeReducer: Reducer<'' | undefined, AnyAction> = (state = '', action) => {
    switch (action.type) {
        default:
            return state;
    }
};

const policyHolderReducer: Reducer<PolicyHolderDetails | undefined, AnyAction> = (
    state: PolicyHolderDetails = {},
    action: AnyAction
) => {
    switch (action.type) {
        default:
            return state;
    }
};

const claimantReducer: Reducer<Claimant | undefined, AnyAction> = (
    state: Claimant = {},
    action: AnyAction
) => {
    switch (action.type) {
        default:
            return state;
    }
};

const employmentReducer: Reducer<Employment | undefined, AnyAction> = (
    state: Employment = {},
    action: AnyAction
) => {
    switch (action.type) {
        default:
            return state;
    }
};

export const formDetailsReducer = combineReducersWithDefault<Nullable<FormDetails>>(
    defaultFormDetails,
    {
        lifeAssured: lifeAssuredReducer,
        declaration: declarationReducer,
        payment: paymentReducer,
        policyHolder: policyHolderReducer,
        claimant: claimantReducer,
        declarationInformation: declarationInformationReducer,
        employment: employmentReducer,
        claimType: claimTypeReducer,
    }
);

export const formDetailsListReducer = (
    state: FormDetails[] = [],
    action: AnyAction
): FormDetails[] => {
    switch (action.type) {
        default:
            return state;
    }
};

export function getFormDetails(state: State): FormDetails {
    return getFormDetailsFromClaim(getClaim(state));
}

export function getFormDetailsList(state: State): FormDetails[] {
    return getFormDetailsListFromClaim(getClaim(state));
}

export function getFormDetailsFromClaim(claim: Claim): FormDetails {
    return getPropertyFromClaim(claim, 'formDetails', defaultFormDetails);
}

export function getFormDetailsListFromClaim(claim: Claim): FormDetails[] {
    return getPropertyFromClaim(claim, 'formDetailsList', defaultFormDetailsList);
}

export function getFormDeclarationFromClaim(claim: Claim): string {
    return getPropertyFromClaim(claim, 'declarationInformation', '');
}

export function getFormClaimTypesFromClaim(claim: Claim): string {
    return getPropertyFromClaim(claim, 'claimType', '');
}

export function getFormDetailsContactDetails(
    claim: Claim,
    financialAdviser: any,
    contactPerson: any
) {
    const formDetails = getPropertyFromClaim(claim, 'formDetails', defaultFormDetails);

    let financialAdviserContact = {};

    if (financialAdviser) {
        financialAdviserContact = {
            telephoneNumber: financialAdviser?.telephoneNumber,
            cellphoneNumber: financialAdviser?.cellphoneNumber,
            faxNumber: financialAdviser?.faxNumber,
            emailAddress: financialAdviser?.emailAddress,
            preferredMethodOfCommunication: financialAdviser.preferredMethodOfCommunication,
            initials: financialAdviser?.initials,
            title: financialAdviser?.title,
            firstName: financialAdviser?.firstName,
            lastName: financialAdviser?.lastName,
            companyName: financialAdviser?.companyName,
            consultantCode: financialAdviser?.consultantCode,
        };
    }

    let contactPersonDetails = {};
    if (contactPerson) {
        contactPersonDetails = {
            telephoneNumber: contactPerson?.sameDetailsAsFa
                ? financialAdviser.telephoneNumber
                : contactPerson.telephoneNumber,
            cellphoneNumber: contactPerson?.sameDetailsAsFa
                ? financialAdviser.cellphoneNumber
                : contactPerson.cellphoneNumber,
            emailAddress: contactPerson?.sameDetailsAsFa
                ? financialAdviser.emailAddress
                : contactPerson.emailAddress,
            faxNumber: contactPerson?.sameDetailsAsFa
                ? financialAdviser.faxNumber
                : contactPerson.faxNumber,
            preferredMethodOfCommunication: contactPerson?.sameDetailsAsFa
                ? financialAdviser.preferredMethodOfCommunication
                : contactPerson.preferredMethodOfCommunication,
            initials: contactPerson?.sameDetailsAsFa
                ? financialAdviser.initials
                : contactPerson?.initials,
        };
    }

    const personalDetails = {
        ...formDetails?.claimant?.personalDetails,
        title:
            formDetails?.claimant?.policyDetails?.claimingCapacity === 'Financial Advisor' ||
            contactPerson?.sameDetailsAsFa
                ? financialAdviser?.title
                : contactPerson?.title,
        firstName:
            formDetails?.claimant?.policyDetails?.claimingCapacity === 'Financial Advisor' ||
            contactPerson?.sameDetailsAsFa
                ? financialAdviser?.firstName
                : contactPerson?.firstName,
        surname:
            formDetails?.claimant?.policyDetails?.claimingCapacity === 'Financial Advisor' ||
            contactPerson?.sameDetailsAsFa
                ? financialAdviser?.lastName
                : contactPerson?.lastName,
        companyName:
            formDetails?.claimant?.policyDetails?.claimingCapacity === 'Financial Advisor' ||
            contactPerson?.sameDetailsAsFa
                ? financialAdviser?.companyName
                : null,
        consultantCode:
            formDetails?.claimant?.policyDetails?.claimingCapacity === 'Financial Advisor' ||
            contactPerson?.sameDetailsAsFa
                ? financialAdviser?.consultantCode
                : null,
    };

    return {
        claimant: {
            contactDetails:
                formDetails?.claimant?.policyDetails?.isOwner === 'Yes' ||
                formDetails?.claimant?.policyDetails?.claimingCapacity === 'Relative'
                    ? contactPersonDetails
                    : financialAdviserContact,
            personalDetails: personalDetails,
            policyDetails: formDetails?.claimant?.policyDetails,
        },
    };
}

export function getContactDetailsFormClaim(claim: Claim) {
    return getPropertyFromClaim(claim, 'contactDetails', {
        financialAdviser: {},
        contactPerson: {},
    });
}

export function getFormDetailsMedicalAidDetails(medicalAidDetails: any) {
    return {
        isLifeAssuredMainMember: medicalAidDetails.isLifeAssuredTheMainMember,
        lifeAssuredMedicalDateJoined: medicalAidDetails.dateJoined,
        lifeAssuredMedicalAidDescription: medicalAidDetails.medicalAidDescription,
        lifeAssuredIdNumber: medicalAidDetails.mainMembersIdNumber,
        lifeAssuredMedicalAidName: medicalAidDetails.medicalAidName,
        lifeAssuredMedicalAidNumber: medicalAidDetails.medicalAidNumber,
        lifeAssuredName: medicalAidDetails.mainMembersFirstName,
        lifeAssuredSurname: medicalAidDetails.mainMembersLastName,
        lifeAssuredTitle: medicalAidDetails.mainMembersTitle,
        doesTheLifeAssuredHaveAMedicalAid: medicalAidDetails.doesTheLifeAssuredHaveAMedicalAid,
        medicalAidName: medicalAidDetails.medicalAidName,
        otherMedicalAidName: medicalAidDetails.otherMedicalAidName,
        medicalAidNumber: medicalAidDetails.medicalAidNumber,
        dateJoined: medicalAidDetails.dateJoined,
        isLifeAssuredMainMemberOnTheMedicalAid:
            medicalAidDetails.isLifeAssuredMainMemberOnTheMedicalAid,
        mainMembersFirstName: medicalAidDetails.mainMembersFirstName,
        mainMembersSurname: medicalAidDetails.mainMembersSurname,
        mainMembersIdNumberOrPassportNumber: medicalAidDetails.mainMembersIdNumberOrPassportNumber,
    };
}
